import { DEVICE_ID_KEY } from "../constants";

/** Get the persistent device UUID for this browser, generating one if absent. */
export function getDeviceId(): string {
  let id = localStorage.getItem(DEVICE_ID_KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(DEVICE_ID_KEY, id);
  }
  return id;
}
